module.exports = __webpack_public_path__ + "img/service-feedback.6cb57fb2.png";